export default {"src":"/_next/static/media/bg.6f55c1b7.svg","height":2213,"width":2541};